<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.globalSearch') }}</h1>
      <form @submit.prevent="loadData">
        <div class="field is-grouped controls">
          <div class="control" style="width: 350px">
            <b-input v-model="q" :placeholder="$t('interface.search')"></b-input>
          </div>
          <div class="control mr-10">
            <button type="submit" class="button is-primary">
              <b-icon icon="magnify" size="is-small"></b-icon>
            </button>
          </div>
        </div>
      </form>
      <div class="results-block mt-20" v-if="searchResults.documents.length > 0">
        <h4 class="subtitle">{{ $t('globalSearch.documents') }} &ndash; {{ searchResults.documents.length }}</h4>
        <div class="columns is-multiline">
          <div class="column is-6" v-for="item in searchResults.documents">
            <div class="search-item">
              <a class="link" @click="detail({id: item.id, type: item.category})">
                {{ $t(`docflow.fullDocTypes.${item.category}`) }}
                {{ item.type__name }}
                <template v-if="item.registration_number"></template>
                №{{ item.registration_number }}
                <b-tag :type="`is-${stateColors[item.state]}`">
                  {{ $t(`workflow.states.${item.state}`) }}
                </b-tag>
              </a>
              <div class="description">{{ item.description }}</div>
              <div class="params">
                <span>{{ $t('docflow.author') }}: {{ item.author__initials }}</span>
                <span v-if="item.register_book__name">
                  {{ $t('docflow.fields.register_book') }}: {{ item.register_book__name }}
                </span>
                <span>{{ $t('interface.date') }}: {{ item.registered_date | localedDateWithYear }}</span>
                <span>{{ $t('documents.fields.term') }}: {{ item.term_date | localedDateWithYear }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="results-block mt-20" v-if="searchResults.assignments.length > 0">
        <h4 class="subtitle">{{ $t('globalSearch.assignments') }} &ndash; {{ searchResults.assignments.length }}</h4>
        <div class="columns is-multiline">
          <div class="column is-6" v-for="item in searchResults.assignments">
            <div class="search-item">
              <a class="link" @click="detail({id: item.id, type: 'assignment'})">
                {{ item.name }}
                <b-tag :type="`is-${stateColors[item.state]}`">
                  {{ $t(`workflow.states.${item.state}`) }}
                </b-tag>
              </a>
              <div class="description">{{ item.description | stripHtml }}</div>
              <div class="params">
                <span>{{ $t('docflow.author') }}: {{ item.author__initials }}</span>
                <span>{{ $t('documents.fields.maintainer') }}: {{ item.maintainer__initials }}</span>
                <span>{{ $t('interface.date') }}: {{ item.created_date | localedDateWithYear }}</span>
                <span>{{ $t('documents.fields.term') }}: {{ item.term_date | localedDateWithYear }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="results-block mt-20" v-if="searchResults.employees.length > 0">
        <h4 class="subtitle">{{ $t('globalSearch.employees') }} &ndash; {{ searchResults.employees.length }}</h4>
        <div class="columns is-multiline">
          <div class="column is-6" v-for="item in searchResults.employees">
            <div class="search-item">
              <a class="link" @click="detail({id: item.id, type: 'employee'})">
                {{ item.last_name }} {{ item.name }} {{ item.patronymic }}
              </a>
              <div class="params">
                <span>{{ $t('admin.department') }}: {{ item.department__name }}</span>
                <span>{{ $t('admin.position') }}: {{ item.position__name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import {mapState} from 'vuex'
  import {stateColors} from '@/colorTypes'
  import DashboardLayout from '@/components/DashboardLayout'

  export default {
    components: {
      DashboardLayout
    },
    data() {
      return {
        q: '',
        stateColors
      }
    },
    methods: {
      loadData() {
        if (this.q && this.q !== '' && this.q.length >= 2)
          this.$store.dispatch('Reference/globalSearch', this.q)
      },
      detail({id, type}) {
        let name, params
        switch (type) {
          case 'assignment':
            name = 'documentDetail'
            params = {documentId: id}
            break;
          case 'employee':
            name = 'employeeDetail'
            params = {employeeId: id}
            break;
          case 'incoming':
            name = 'docflowIncomingDetail'
            params = {documentId: id}
            break;
          case 'outgoing':
            name = 'docflowOutgoingDetail'
            params = {documentId: id}
            break;
          case 'appeal':
            name = 'docflowAppealDetail'
            params = {documentId: id}
            break;
        }
        this.$router.push({name, params})
      }
    },
    mounted() {
      this.$store.commit('Reference/CLEAR', 'searchResults')
      if (this.$route.query.q) {
        this.q = this.$route.query.q
        this.loadData()
      }
    },
    computed: {
      ...mapState('Reference', ['searchResults']),
      breadcrumbs() {
        return [
          {name: 'globalSearch'}
        ]
      }
    }
  }
</script>

<style scoped lang="scss">
  .subtitle {
    margin-bottom: 15px;
  }

  .search-item {
    margin-bottom: 5px;

    .link {
      color: #3498db;
      font-size: 15px;
      display: inline-block;
      margin-bottom: 5px;
    }

    .params {
      margin-top: 2px;
      color: #aaa;
      font-size: 13px;

      span {
        display: inline-block;
        width: 50%;
      }
    }
  }
</style>